// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__1CIsA","title":"style_title__3BICS","time":"style_time__1Zya5","content":"style_content__3TrLJ"};